import { useWorksheetChecklist } from '../../../queries/use-worksheet-checklist';
import { Worksheet } from '../../../types/worksheet';
import ChecklistCategory from './ChecklistCategory';

type ChecklistProps = {
    worksheet: Worksheet;
    compactView?: boolean;
};

function Checklist({ worksheet, compactView = false }: ChecklistProps): JSX.Element {
    const checklistQuery = useWorksheetChecklist(worksheet.id);

    if (checklistQuery.isLoading) {
        return <></>;
    }

    if (!checklistQuery.isSuccess) {
        return <></>;
    }

    const { categories, items } = checklistQuery.data;

    const hasUncategorisedItems = items.some((item) => !item.categoryId);

    return (
        <div>
            {categories.map((category) => {
                return (
                    <ChecklistCategory
                        key={category.id}
                        category={category}
                        items={items.filter((i) => i.categoryId === category.id)}
                        worksheetId={worksheet.id}
                        compactView={compactView}
                    />
                );
            })}
            {hasUncategorisedItems && (
                <ChecklistCategory items={items.filter((i) => !i.categoryId)} worksheetId={worksheet.id} compactView={compactView} />
            )}
        </div>
    );
}
export default Checklist;
